import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Container,
  Paper,
  Avatar,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNavigate } from "react-router-dom";
import CommonFieldsScreen from "./CommonFields"; 
import PhysiotherapyatHome from "../Logos/Nursing/PhysiotherapyatHome.png";
import Footer from "../Common/Footer";
import { fetchUserFromRedis } from "../HomePage/AuthonticationScreens/Register";
const NursingPysiotherapyScreen = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);


  useEffect(() => {
    const fetchUser = async () => {
      // Try to get latest user from sessionStorage
      const storedUser = sessionStorage.getItem("user");
      if (storedUser) {
        setUser(JSON.parse(storedUser));
      }

      // Always fetch fresh data from Redis if token exists
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      if (!userId || !token) return;

      try {
        const userData = await fetchUserFromRedis(userId, token);
        if (userData) {
          setUser(userData);
          sessionStorage.setItem("user", JSON.stringify(userData)); // update sessionStorage
        }
      } catch (err) {
        console.error("Error fetching user from Redis:", err);
        setUser(null);
      }
    };

    fetchUser();
  }, []);
  const handleBackToServices = () => {
    sessionStorage.removeItem("commonFormData");
    navigate("/services");
  };

  return (
    <>
      {/* Top Navigation */}
  

      <Container maxWidth="sm" sx={{ py: 3 }}>
         <Paper sx={{ p: 3, borderRadius: 3 ,width:"120%"}}>
          {/* Header */}
          <Box mb={3}>
             <IconButton onClick={handleBackToServices}>
              <ArrowBackIosNewIcon />
            </IconButton>

            <Box display="flex" alignItems="center" mt={4}>
              <Avatar
                src={PhysiotherapyatHome}
                alt="Physiotherapy at Home"
                sx={{ width: 150, height: 150, borderRadius: 2 }}
              />
              <Box ml={6}>
                <Typography fontSize={20} fontWeight={700} color="text.primary">
                NURSING & PHYSIOTHERAPY SERVICES
                </Typography>
                <Typography
                  fontSize={16}
                  color="text.secondary"
                  mt={1.0}
                  sx={{ maxWidth: 320 }}
                >
                  Ayuja Will Choose Right People For The Timing Of Your Selection
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Form Section */}
          <CommonFieldsScreen
            serviceData={{
              serviceTitle: "NURSING & PHYSIOTHERAPY SERVICES",
              serviceImage: PhysiotherapyatHome,
            }}
          />
        </Paper>
      </Container>
      <Footer/>
    </>
  );
};

export default NursingPysiotherapyScreen;
